import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as messageActions from '../../../modules/message'
import {APP_CONFIG} from '../../../utils/config'
import {openUrl} from '../../../utils/utils'

class ButtonItem extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    linkMessage(q) {
        let sendData = {
            "utterance" : q, 
            "sessionKey" : this.props.message.sessionKey,
            "channelId" : this.props.message.channelId,
            "isLogin" : this.props.message.isLogin,
            "isDev" : this.props.config.isDev,
            "blockId" : "",
            "projectId" : this.props.config.projectId
        }

        this.props.send(sendData);
        // console.log("Button Message Click!!!")
    }

    linkBlockId(blockId, q) {
        let sendData = {
            "utterance" : q, 
            "sessionKey" : this.props.message.sessionKey,
            "channelId" : this.props.message.channelId,
            "isLogin" : this.props.message.isLogin,
            "isDev" : this.props.config.isDev,
            "blockId" : blockId,
            "projectId" : this.props.config.projectId        
        }

        this.props.send(sendData);
        // console.log("Button BlockId Click!!!")
    }

	LinkButtonInput(inputValue, q) {
        let sendData = {
            "utterance" : q, 
            "sessionKey" : this.props.message.sessionKey,
            "channelId" : this.props.message.channelId,
            "isLogin" : this.props.message.isLogin,
            "isDev" : this.props.config.isDev,
            "projectId" : this.props.config.projectId,
            "blockId" : this.props.message.dialogTaskId,
            "blockName" : "BUTTON_INPUT",
            "inputValue" : inputValue
        }

        this.props.send(sendData);
        // console.log("Button BlockId Click!!!")
    }
    
    linkPhone(phoneNum) { //앱에서의 전화와 앱에서의 전화를 구분
        if (this.props.fromApp) {
            window.openUrl("tel", "tel:" + phoneNum)
        } else {
            document.location.href = "tel:" + phoneNum;
        }
    }

    clickWebLink(url, target) {
        let windowTarget = target
        if (windowTarget !== undefined || windowTarget === "") windowTarget = APP_CONFIG.popWinTarget
        openUrl(url, windowTarget, this.props.fromApp)
    }

	/*
: button.action === 'block' 
    ? (<button className="btn btn_block" type="button" value={button.blockId} key={index} onClick={this.handleClickBlockId}>{button.label}</button>)
    : button.action === 'input' && (<button className="btn btn_block" type="button" value={button.inputValue} key={index} onClick={this.handleClickButtonInput}>{button.label}</button>)
	*/
    render() {
        let buttons = "";
        if  (this.props.data !== null && this.props.data !== undefined && this.props.data !== '' && this.props.data.length > 0) {
            buttons = this.props.data.map (
                (button, index) => (
                    button.action === 'webLink' 
                        ? <a className="btn_link" href="#none" onClick={()=>this.clickWebLink(button.webLinkUrl,button.target)} key={index}>{button.label}</a>
                        :  button.action === 'message' 
                            ? <a className="btn_link" href="#none" onClick={()=>{this.linkMessage(button.messageText)}} key={index}>{button.label}</a>
                            : button.action === 'phone' 
                                ? <a className="btn_link" href="#none" onClick={()=>{this.linkPhone(button.phoneNumber)}} key={index}>{button.label}</a>
                                : button.action === 'block' 
									? <a className="btn_link" href="#none" onClick={()=>{this.linkBlockId(button.blockId, button.label)}} key={index}>{button.label}</a>
									: button.action === 'input' && (<a className="btn_link" href="#none" onClick={()=>{this.LinkButtonInput(button.inputValue, button.label)}} key={index}>{button.label}</a>)
                )
            )
        } 
        return (<div className='btn_group'>{buttons}</div>)
    }
};

function mapStateToProps(state) {
    return {...state};
}

function mapDispatchToProps(dispatch) {
    return {send:(payload) => dispatch(messageActions.sendMessage(payload))};
}

export default connect(mapStateToProps, mapDispatchToProps)(ButtonItem);